module.exports = __webpack_public_path__ + "img/thigh.f3e44d5a.png";